<script>
import Banner from 'dashboard/components/ui/Banner.vue';

export default {
  components: { Banner },
  data() {
    return {
      showBanner: false,
      swRegistration: null,
    };
  },
  mounted() {
    window.addEventListener('pwa-update-available', this.onUpdateAvailable);
  },
  unmounted() {
    window.removeEventListener('pwa-update-available', this.onUpdateAvailable);
  },
  methods: {
    onUpdateAvailable(event) {
      this.swRegistration = event.detail.registration;
      this.showBanner = true;
    },
    async applyUpdate() {
      const { swRegistration } = this;
      if (!swRegistration || !swRegistration.waiting) return;

      swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });

      navigator.serviceWorker.addEventListener(
        'controllerchange',
        () => window.location.reload(),
        { once: true }
      );
    },
  },
};
</script>

<template>
  <Banner
    v-if="showBanner"
    color-scheme="warning"
    :banner-message="$t('GENERAL_SETTINGS.PWA_UPDATE.AVAILABLE')"
    has-action-button
    :action-button-label="$t('GENERAL_SETTINGS.PWA_UPDATE.RELOAD')"
    action-button-icon="i-lucide-refresh-cw"
    @primary-action="applyUpdate"
  />
</template>
